import React, { useState, useEffect } from 'react';
import {
    Dialog,
    Card,
    Typography,
    makeStyles,
    CardContent,
    Box,
    Button,
} from '@material-ui/core';
import { CapitalizeNames } from 'src/utils/capitalize';
import { Document, Page } from 'react-pdf/dist/esm/entry.webpack';
import { ArrowRight, ArrowLeft } from 'react-feather';
import Spinner from 'src/components/Spinner';
import PerfectScrollbar from 'react-perfect-scrollbar';

const useStyles = makeStyles((theme) => ({
    root: {},
    card: {
        padding: 30,
        minWidth: '150ch',
    },
    imageContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    image: {
        maxWidth: '100%',
        maxHeight: '85vh',
        objectFit: 'contain',
    },
}));

const imagesExt = ['png', 'jpeg', 'gif', 'jpg'];
const filesExt = ['pdf'];

const ModalImage = ({ open, setOpen, source, title, ...rest }) => {
    const classes = useStyles();

    //eslint-disable-next-line
    const [numPages, setNumPages] = useState(null);
    //eslint-disable-next-line
    const [pageNumber, setPageNumber] = useState(1);
    const [width, setWidth] = useState(100);
    const [typeFile, setTypeFile] = useState(null);

    const [error, setError] = useState({
        status: false,
        message: '',
        e: '',
    });

    const onDocumentLoadSuccess = ({ numPages }) => {
        setNumPages(numPages);
        if (document.getElementById('containerPDF'))
            setWidth(document.getElementById('containerPDF').offsetWidth);
    };

    useEffect(() => {
        if (source) {
            const type = source.split('.')[source.split('.').length - 1];

            if (imagesExt.includes(type.toLowerCase()))
                return setTypeFile('image');
            if (filesExt.includes(type.toLowerCase()))
                return setTypeFile('pdf');

            if (source.startsWith('blob:')) return setTypeFile('blob');
        }
        //eslint-disable-next-line
    }, [source]);

    return (
        <Dialog
            onClose={(e) => setOpen(false)}
            open={open}
            className={classes.root}
            maxWidth="lg"
            {...rest}
        >
            <PerfectScrollbar options={{ suppressScrollX: true }}>
                <Card className={classes.card}>
                    <center>
                        <Typography variant="h3" color="textPrimary">
                            {CapitalizeNames(title)}
                        </Typography>
                    </center>
                    <CardContent style={{ overflow: 'scroll' }}>
                        {(typeFile === 'image' || typeFile === 'blob') && (
                            <div className={classes.imageContainer}>
                                <img
                                    src={source}
                                    alt={source}
                                    className={classes.image}
                                />
                            </div>
                        )}

                        {error.status ? (
                            <Box display="flex" justifyContent="center">
                                <Typography variant="h4" color="textPrimary">
                                    {error.message.details}
                                </Typography>
                            </Box>
                        ) : (
                            typeFile === 'pdf' && (
                                <div
                                    style={{ width: '100%' }}
                                    id="containerPDF"
                                >
                                    <Document
                                        file={source}
                                        onLoadSuccess={onDocumentLoadSuccess}
                                        loading={<Spinner width={50} />}
                                        onLoadError={(e) =>
                                            setError({
                                                status: true,
                                                message: e.message,
                                                e,
                                            })
                                        }
                                    >
                                        <Page
                                            pageNumber={pageNumber}
                                            width={width}
                                        />
                                        <Box
                                            display="flex"
                                            style={{ marginTop: '1em' }}
                                        >
                                            <Box flexGrow={1}>
                                                <Button
                                                    color="primary"
                                                    variant="contained"
                                                    disabled={
                                                        pageNumber - 1 === 0
                                                    }
                                                    onClick={() =>
                                                        setPageNumber(
                                                            pageNumber - 1
                                                        )
                                                    }
                                                >
                                                    <ArrowLeft />
                                                </Button>
                                            </Box>
                                            <Box>
                                                <Button
                                                    color="primary"
                                                    variant="contained"
                                                    disabled={
                                                        pageNumber === numPages
                                                    }
                                                    onClick={() =>
                                                        setPageNumber(
                                                            pageNumber + 1
                                                        )
                                                    }
                                                >
                                                    <ArrowRight />
                                                </Button>
                                            </Box>
                                        </Box>
                                    </Document>
                                </div>
                            )
                        )}
                    </CardContent>
                </Card>
            </PerfectScrollbar>
        </Dialog>
    );
};

export default ModalImage;
